import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, DigitalCorrespondanceTable, Dictionary, DigitalSet, DropObject, DigitalCorrespondanceLayer, Identifier } from '@models/index';
import { rebuildViewModels } from './rebuildViewModels';
import { CorrespondanceTableViewModel } from './CorrespondanceTableViewModel';

class CorrespondanceTableTilesController implements angular.IComponentController {

    ctvm: CorrespondanceTableViewModel[];

    readonly correspondanceTables: Dictionary<DigitalCorrespondanceTable>;
    readonly digitalSets: Dictionary<DigitalSet>;
    readonly isEditMode: boolean;
    readonly identifiers: Dictionary<Identifier>;
    readonly onLayerDeleteClick: (value: { layer: DigitalCorrespondanceLayer, $index: number }) => void;
    readonly onTableClick: (value: { table: DigitalCorrespondanceTable }) => void;
    readonly onTableDeleteClick: (value: { table: DigitalCorrespondanceTable }) => void;
    readonly onTableSetDrop: (value: { table: DigitalCorrespondanceTable, digitalSetGuid: string, targetLayerSetGuid: string }) => void;
    readonly selectedTable: DigitalCorrespondanceTable;

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['correspondanceTables'] || changesObj['digitalSets'] || changesObj['valueViewModels']) {
            this.ctvm = rebuildViewModels(this.correspondanceTables, this.digitalSets, this.identifiers);
        }
    }

    onDropDigitalSet(data: DropObject, layer: DigitalSet) {
        if (data.itemId?.startsWith('digitalSet')) {
            const dsGuid = data.itemId.replace('digitalSet', '');
            if (data.binId?.startsWith('corrTable')) {
                const ctGuid = data.binId.replace('corrTable', '');
                const ct = this.correspondanceTables[ctGuid];
                if (this.onTableSetDrop) {
                    this.onTableSetDrop({ table: ct, digitalSetGuid: dsGuid, targetLayerSetGuid: layer?.guid });
                }
            }
        }
    }

    onReplaceDigitalSet(data: DropObject, layer: DigitalSet, table: CorrespondanceTableViewModel) {
        if (data.itemId?.startsWith('digitalSet')) {
            const dsGuid = data.itemId.replace('digitalSet', '');
            if (table) {
                const ct = table.table;
                if (this.onTableSetDrop) {
                    this.onTableSetDrop({ table: ct, digitalSetGuid: dsGuid, targetLayerSetGuid: layer?.guid });
                }
            }
        }
    }

    layerDeleteClick(layer: DigitalCorrespondanceLayer, $index: number, $event: angular.IAngularEvent) {
        if (this.onLayerDeleteClick) {
            this.onLayerDeleteClick({ layer, $index });
        }
        this.stopPropagation($event);
    }

    tableDeleteClick(table: DigitalCorrespondanceTable, $event: angular.IAngularEvent) {
        if (this.onTableDeleteClick) {
            this.onTableDeleteClick({ table });
        }
        this.stopPropagation($event);
    }

    tableClick(table: DigitalCorrespondanceTable, $event: angular.IAngularEvent) {
        if (this.onTableClick) {
            this.onTableClick({ table });
        }
        this.stopPropagation($event);
    }

    private stopPropagation($event: angular.IAngularEvent) {
        if ($event) {
            if ($event.preventDefault) {
                $event.preventDefault();
            }
            $event.stopPropagation();
        }
    }
}

export const wtCorrespondanceTableTiles: ComponentDefinition = {
    componentId: 'wtCorrespondanceTableTiles',
    controller: CorrespondanceTableTilesController,
    template: require('./correspondanceTableTiles.component.html'),
    controllerAs: 'vm',
    bindings: {
        correspondanceTables: '<',
        digitalSets: '<',
        identifiers: '<',
        isEditMode: '<?',
        onLayerDeleteClick: '&?',
        onTableClick: '&?',
        onTableDeleteClick: '&?',
        onTableSetDrop: '&?',
        selectedTable: '<?'
    }
};
